export default {
  推荐66人: `Giới thiệu 66 người – Mời bạn trực tiếp đến Barca`,
  成为EBC推荐官: "Trở thành Đại sứ EBC và tận hưởng đặc quyền VIP",
  立即参与: "THAM GIA NGAY",
  活动规则与要求: "Quy tắc & Yêu cầu của Sự kiện",
  每一次推荐: "Mỗi lần giới thiệu là một pha kiến tạo vàng để mở ra cánh cửa đến Barca.",
  参与规则: "Quy tắc tham gia:",
  成为EBC推荐官并邀请66人: "Trở thành Đại sứ giới thiệu của EBC và mời đủ 66 người;",
  所有被邀请人均入金大于等于$500: `Mỗi người được mời phải nạp tối thiểu 500 đô la Mỹ và hoàn tất giao dịch.`,
  参与方法: "Cách tham gia:",
  立即推荐: "Giới thiệu ngay để nhận sự hỗ trợ từ bạn bè, tri ân huyền thoại.",
  登录EBC用户中心: "Đăng nhập Trung tâm người dùng EBC",
  "进入“大赛推荐官”活动页面": "Vào trang hoạt động “Đại sứ giới thiệu cuộc thi”",
  生成您的邀请链接或二维码: "Tạo liên kết mời hoặc mã QR cá nhân của bạn",
  巴萨荣耀之旅: "Hành trình vinh quang đến Barcelona",
  每笔订单都是攻守博弈的艺术: `Mỗi giao dịch là sự cân bằng tinh tế giữa tấn công và phòng thủ. Mỗi quyết định bạn đưa ra có thể trở thành bàn thắng quyết định trên thị trường. Vinh quang đang chờ đón những người chiến thắng.`,
  活动时间: "Thời gian chương trình:",
  "2025年2月22日": "22/02/2025 01:00:00 (giờ MT4/MT5) - 08/2025 (giờ MT4/MT5)",
  活动规则: "Quy định chương trình",
  ruleList: [
    "Hoạt động này không xung đột với phần thưởng giới thiệu thông thường và các chương trình khác.",
    "Người được giới thiệu phải hoàn tất nạp tiền và thực hiện giao dịch, các khoản chuyển khoản từ bên thứ ba không hợp lệ.",
    "Tiền thưởng giới thiệu chỉ áp dụng cho những nhà giao dịch tuân thủ quy định. EBC có toàn quyền thu hồi tiền thưởng nếu vi phạm.",
    "tài khoản đăng ký thông qua giới thiệu không được phép chuyển nhượng đại lý.",
    "Phần thưởng sẽ được trao khi tài khoản được kích hoạt hợp lệ; ghế xem VIP bao gồm vé máy bay và chỗ ở.",
    "EBC sở hữu quyền giải thích cuối cùng đối với sự kiện này.",
  ],
};
